import React, { useState } from 'react';
import { useAuth } from '../auth/AuthContext';
import AuthScreen from '../auth/AuthScreen';
import { useMenuClose } from '../hooks/useMenuClose';

export default function UserMenu() {
  const { user, loading, logout } = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  const [open, setOpen] = useState(false);
  useMenuClose(open, () => setOpen(false));

  if (loading) return null;

  // A guest is signed in to a throwaway sandbox account — treat it like signed-out
  // in the nav (don't surface the synthetic guest email), but prompt to save.
  if (!user || user.is_guest) {
    return (
      <>
        <button type="button" className="tp-navlink tp-navlink--btn" onClick={() => setShowAuth(true)}>
          {user?.is_guest ? 'Sign in to save' : 'Sign in'}
        </button>
        {showAuth && <AuthScreen onClose={() => setShowAuth(false)} />}
      </>
    );
  }

  const initial = (user.display_name || user.email || '?').slice(0, 1).toUpperCase();
  return (
    <div style={{ position: 'relative' }}>
      <button
        type="button"
        className={open ? 'tp-navlink tp-navlink--active tp-navlink--btn' : 'tp-navlink tp-navlink--btn'}
        onClick={(e) => { e.stopPropagation(); setOpen((v) => !v); }}
        title={user.email}
        aria-label="Account"
      >
        {initial}
      </button>
      {open && (
        <div
          className="tp-card tp-card--tight tp-menu"
          style={{ position: 'absolute', right: 0, top: 'calc(100% + 8px)', minWidth: 180, zIndex: 100 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ padding: '6px 8px 8px' }}>
            <div style={{ fontWeight: 700, fontSize: 13 }}>{user.display_name || 'You'}</div>
            <div style={{ color: 'var(--tp-muted, #9aa4b2)', fontSize: 12 }}>{user.email}</div>
          </div>
          <button
            type="button"
            className="tp-navlink"
            style={{ width: '100%', textAlign: 'left' }}
            onClick={async () => { setOpen(false); await logout(); }}
          >
            Log out
          </button>
        </div>
      )}
    </div>
  );
}
